import React, { Component } from "react";
import { Form } from "reactstrap";
import config from "config";
import { validateEmail } from "../../../utils/globals";
import { XoxodayLongLogo } from "../../../components/Icons";
import {
  Input,
  Button,
  Dropdown,
  Icon,
  CircularLoader,
} from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { TURNSTILE_SITE_KEY } from "../../../constants/AppConstant";
import { EditInfoInput } from "../../Accounts/PlatformPreferences/Component/styled";
import profileService from "../../../services/profileService";
import { phone_codes } from "../../../utils/locales";
import debounce from "lodash/debounce";

const INVALID_EMAIL_ERROR =
  "Invalid email. Please provide a valid email address.";

const StyledPasswordShow = styled.span`
  color: ${(props) => props.theme.palette.primary.c03};
  right: 12px;
  top: 50%;
  transform: translate(0px, -50%);
  cursor: pointer;
`;
// const site_key = "6Lcj-NAUAAAAALVs-_xpCyWWAGHfe6N028AvFro_";

var strongRegex = new RegExp(
  "^(?!.* )(?=.*[$&+,:;=?@#|'<>.^*()%!-])(?=.*[0-9])(?=.{8,})"
);

const CustomDropdown = styled(Dropdown).attrs()`
  width: 145px !important;
`;

const StyledInput = styled(Input).attrs()`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px
      ${(props) => props.theme.palette.background.tertiary} inset !important;
  }
`;
const GreySpan = styled.span`
  color: ${(props) => props.theme.palette.primary.c02};
  border-color: ${(props) => props.theme.palette.primary.c02};
`;
const BlueSpan = styled.span`
  color: ${(props) => props.theme.palette.primary.c02};
`;
const HeaderDiv = styled.hr`
  border-color: ${(props) => props.theme.palette.dark.c200};
  opacity: 0.2;
`;

class FirstStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showPassInput: false,
      focus: false,
      showEmailInfo: false,
      toggle: false,
      isd_code_object: {
        country_id: 99,
        iso: "IN",
        label: "IN +91",
        name: "India",
        phonecode: "+91",
        value: 99,
        errorPhone: "",
      },
    };
  }
  componentDidMount() {
    this.getPhoneCodes();
  }

  toggleFocus = () => {
    this.setState((state) => ({
      focus: !state.focus,
    }));
  };
  getPhoneCodes = () => {
    const phone_codes_ui =
      phone_codes &&
      phone_codes.map((item) => {
        let obj = item;
        obj.label = item.iso + " " + item.phonecode;
        obj.value = item.country_id;
        return obj;
      });
    this.setState({
      phone_codes_ui,
    });
    this.getDefaultIsd(phone_codes_ui);
  };

  getDefaultIsd = (phone_codes_ui) => {
    profileService.fetchCountryBasedonIP().then((response) => {
      if (response && response.plumApi && response.plumApi.output) {
        let { employeeDetails: { employee_primary_mobile } = {} } = this.props;
        const splitNum = employee_primary_mobile?.split("-") || [];
        const employeePhnCode = splitNum.length >= 1 ? splitNum[0] : "";
        if (employeePhnCode === "") {
          const ipBasedOutput = JSON.parse(response.plumApi.output);
          let countryCode = "IN";
          if (ipBasedOutput.success && ipBasedOutput.success === 1) {
            countryCode = ipBasedOutput.country_code;
          }
          const phonecodeDetails = phone_codes_ui.find(
            (item) => item.iso == countryCode
          );
          this.setState({ isd_code_object: phonecodeDetails });
          const userDetails = { phoneCode: phonecodeDetails };
          this.props.updateState({ userDetails });
        } else {
          const phonecodeDetails = phone_codes_ui.find(
            (item) => item.phonecode == employeePhnCode
          );
          this.setState({ isd_code_object: phonecodeDetails });
          const userDetails = { phoneCode: phonecodeDetails };
          this.props.updateState({ userDetails });
        }
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isEmailChangeClicked !== prevProps.isEmailChangeClicked &&
      this.props.isEmailChangeClicked
    ) {
      if (this.props.emailInputRef && this.props.emailInputRef.current) {
        setTimeout(() => this.props.emailInputRef.current.focus(), 1000);
      }

      const { userDetails, error } = this.props;
      userDetails.email = "";
      userDetails.pwd = "";
      delete error.email;
      delete error.pwd;
      error.pwd = "";
      this.setState({ showPassInput: false, showEmailInfo: false });

      this.props.updateState({
        userDetails,
        error,
        isEmailChangeClicked: false,
      });
    }
  }

  inputChangeHandler = (tag, event) => {
    const { userDetails, error = {} } = this.props;
    if (tag === "firstname") {
      if (event.target.value == "") {
        error["firstname"] = "Please enter your name.";
      } else {
        delete error["firstname"];
      }
      const nameCamelCase =
        event &&
        event.target &&
        event.target.value &&
        event.target.value
          .toLowerCase()
          .replace(/\s(.)/g, ($1) => $1.toUpperCase())
          .replace(/^(.)/g, ($1) => $1.toUpperCase())
          .trimStart();
      userDetails[tag] = nameCamelCase;
    } else {
      if (tag === "pwd") {
        const pwdNotAllowSpace = event.target.value.replace(/ /g, "");
        if (pwdNotAllowSpace.length > 68) {
          return;
        }
        userDetails[tag] = pwdNotAllowSpace;
        this.setState({
          showPassInput: userDetails.pwd ? true : false,
          focus: false,
        });

        if (pwdNotAllowSpace) {
          error["pwd"] = "Please enter a valid password.";
        }

        if (pwdNotAllowSpace.match(strongRegex)) {
          error["pwd"] = "";
          delete error.pwd;
        } else {
          if (event.target.value == "") {
            error["pwd"] =
              "Must contain at least 8 characters, 1 numeric and 1 special character.";
          } else {
            error["pwd"] =
              "Must contain at least 8 characters, 1 numeric and 1 special character.";
          }
        }
      } else if (tag === "company_name") {
        if (event.target.value == "") {
          error["company_name"] = "Please enter your company name.";
        } else {
          delete error["company_name"];
        }
        userDetails[tag] = event.target?.value
          ?.replace(/[^a-zA-Z ]/g, "")
          ?.trimStart();
      } else if (tag === "email") {
        error["email"] = "";
        userDetails[tag] = event?.target?.value?.trim();
        let email = event?.target?.value?.trim();

        if (!email) {
          error["email"] = "Please enter your email.";
          this.props.updateState({ signupLoader: false });
          return;
        }
        if (typeof email !== "undefined") {
          if (validateEmail(email)) {
            const lastAtPos = email.lastIndexOf("@");
            const lastDotPos = email.lastIndexOf(".");
            const re = /.+@(gmail|yahoo)\.com$/;
            if (
              lastAtPos < lastDotPos &&
              lastAtPos > 0 &&
              email.indexOf("@@") == -1 &&
              lastDotPos > 2 &&
              email.length - lastDotPos > 2
            ) {
              if (email.match(re)) {
                error["email"] = "Only company email is allowed.";
              } else {
                error["email"] = "";
                delete error.email;
                this.setState({ showEmailInfo: true });
              }
            } else {
              error["email"] = INVALID_EMAIL_ERROR;
            }
          } else {
            error["email"] = INVALID_EMAIL_ERROR;
          }
          email && this.props.handleEmailBlur(email);
        }
      } else if (tag === "phoneNumber") {
        const regex = /^\d+$/;
        if (event.target.value.length > 16) {
          return;
        }
        userDetails[tag] = event.target.value.trim();
        if (
          !(event.target.value.length == 0 && event.target.value == "") &&
          !regex.test(event.target.value)
        ) {
          this.setState({
            phoneNumber: "",
            errorPhone:
              event.target.value.length > 0 && event.target.value.length < 7
                ? "Phone number should be between 7 to 16 digits."
                : "",
          });
          return;
        } else {
          userDetails[tag] = event.target.value;
          this.setState({
            phoneNumber: event.target.value,
            modified: true,
            errorPhone:
              event.target.value.length > 0 && event.target.value.length < 7
                ? "Phone number should be between 7 to 16 digits."
                : "",
          });
        }
      } else if (tag === "phoneCode") {
        userDetails[tag] = event;
        this.setState({ phoneNumber: "", errorPhone: "" });
        this.setState({
          isd_code_object: event,
          modified: true,
        });
      } else {
        userDetails[tag] = event.target.value;
      }
    }
    this.props.updateState({ userDetails, error });
  };

  debounceInputChangeHandler = debounce((tag, event) => {
    this.inputChangeHandler(tag, event);
  }, 700);

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const {
      userDetails,
      error,
      signupLoader,
      handleEmailBlur,
      renderTurnstileCaptcha = false,
    } = this.props;
    const {
      showPassword,
      phoneNumber,
      phone_codes_ui,
      isd_code_object,
      errorPhone,
    } = this.state;
    const url = config.storeFrontUrl.replace(/\/$/g, "");

    const CompanyExistsView = (
      <div className="d-flex flex-column">
        <div>
          <Icon
            iconName="PlumWarning"
            onClick={() => {}}
            size="48"
            className="ml-0"
            color="warning"
            shade="c03"
          />
        </div>
        <Typography.H1
          component="div"
          color="dark"
          shade="c300"
          className="mt-24"
        >
          Looks like your company is already registered with us
        </Typography.H1>
        <Typography component="div" color="dark" shade="c200" className="mt-4">
          To redeem your reward codes or points provided by your organization,
          please click on "Redeem Rewards" to proceed.
        </Typography>
        <div className="mt-24">
          <a href={`${url}/marketplace/vouchers`}>
            <Button>Redeem Rewards</Button>
          </a>
        </div>
        <div className="mt-24">
          <hr />
        </div>
        <Typography.H2
          className="mt-24"
          component="div"
          color="dark"
          shade="c300"
        >
          I don't want to redeem
        </Typography.H2>
        <Typography component="div" color="dark" shade="c300" className="mt-4">
          By proceeding, you will be creating an admin account for your
          organization. It will enable you to send and manage rewards
          efficiently.
        </Typography>
        <div className="mt-24">
          {renderTurnstileCaptcha ? (
            <Turnstile
              className="text-center"
              siteKey={TURNSTILE_SITE_KEY}
              onSuccess={(token) => this.props.signUpFlow(token, false)}
              options={{ theme: "light" }}
              style={{ width: "100%" }}
            />
          ) : (
            <Button
              variant="outlined"
              onClick={() =>
                !signupLoader ? this.props.changeStep(false) : ""
              }
              loading={signupLoader}
            >
              Start Business Trial
            </Button>
          )}
        </div>
      </div>
    );
    return (
      <>
        <Typography component="div" className="d-flex justify-content-center">
          <XoxodayLongLogo width="135" height="40" />
        </Typography>

        <HeaderDiv className="mt-24 mb-16" />

        <div className="step-one">
          {!this.props.domainExists ? (
            <div className="detailsContent">
              <Typography.H1 color="dark" shade="c300">
                Welcome to Xoxoday Plum
              </Typography.H1>
              <Typography.ButtonText
                color="dark"
                shade="c200"
                className="mb-16 mt-4"
              >
                Let us create your business account.
              </Typography.ButtonText>
              {/* <div className="text-ink-light">
            Please fill up the following details and get started in minutes
          </div> */}
              <div className="inputForm">
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    !signupLoader ? this.props.changeStep() : "";
                  }}
                >
                  <div className="row">
                    <div className="col-12 mb-20">
                      <div className="text-left">
                        <div className="d-flex justify-content-between">
                          <StyledInput
                            autoComplete="off"
                            // className={"modalInput"}
                            label="Name"
                            type="text"
                            id="firstname"
                            placeholder="Enter your full name"
                            value={
                              userDetails.firstname ? userDetails.firstname : ""
                            }
                            onChange={(e) =>
                              this.inputChangeHandler("firstname", e)
                            }
                            error={error.firstname}
                            helperText={error.firstname}
                            required={true}
                            className="w-50"
                          />

                          <StyledInput
                            autoComplete="off"
                            label="Company Name"
                            className="modalInput ml-16 w-50"
                            type="text"
                            id="company_name"
                            placeholder="Enter your company name"
                            value={userDetails.company_name}
                            onChange={(e) =>
                              this.inputChangeHandler("company_name", e)
                            }
                            required={true}
                            error={error.company_name}
                            helperText={error.company_name}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="text-left">
                        <div>
                          <StyledInput
                            autoComplete="off"
                            label="Company Email Address"
                            className={
                              error.email ? "modalInput" : "modalInput"
                            }
                            type="text"
                            id="email"
                            placeholder="Enter your company email (john@company.com)"
                            value={userDetails.email}
                            suffix={signupLoader && <CircularLoader />}
                            onChange={(e) => {
                              e.persist();
                              userDetails["email"] = e?.target?.value;
                              this.props.updateState({
                                userDetails,
                                signupLoader: true,
                              });
                              this.debounceInputChangeHandler("email", e);
                            }}
                            // onBlur={() => {
                            //   this.props.updateState({ signupLoader: true });
                            //   handleEmailBlur(userDetails.email);
                            // }}
                            required={true}
                            error={error.email}
                            helperText={
                              error.email
                                ? error.email
                                : !error.email &&
                                  this.state.showEmailInfo &&
                                  `We'll send you an OTP for verification.`
                            }
                            ref={this.props.emailInputRef}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="text-left">
                        <div className="d-flex">
                          <CustomDropdown
                            options={phone_codes_ui}
                            onChange={(e) => {
                              this.inputChangeHandler("phoneCode", e);
                            }}
                            placeholder={"ISD Code"}
                            value={isd_code_object}
                            isSearchable={true}
                            label="Phone Number"
                            className="pr-4"
                          />
                          <StyledInput
                            className="w-100 mt-20"
                            placeholder="Enter your phone number (optional)"
                            value={phoneNumber}
                            onChange={(e) => {
                              e.preventDefault();
                              this.inputChangeHandler("phoneNumber", e);
                            }}
                            error={errorPhone}
                            helperText={errorPhone !== "" && errorPhone}
                          ></StyledInput>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-16">
                      <div className="text-left">
                        <div className="-pos-rel">
                          <StyledInput
                            autoComplete="off"
                            label="Password"
                            className={
                              error.pwd ? "pwdError modalInput" : "modalInput"
                            }
                            type={showPassword ? "text" : "password"}
                            id="password"
                            placeholder="Set your password"
                            value={userDetails.pwd}
                            onChange={(e) => {
                              e.persist();
                              userDetails["pwd"] = e?.target?.value;
                              this.props.updateState({ userDetails, error });
                              this.debounceInputChangeHandler("pwd", e);
                            }}
                            onFocus={this.toggleFocus}
                            onBlur={this.toggleFocus}
                            required={true}
                            endIcon={
                              userDetails?.pwd && (
                                <StyledPasswordShow
                                  aria-hidden="true"
                                  onClick={() => this.handleClickShowPassword()}
                                >
                                  {showPassword ? "Hide" : "Show"}
                                </StyledPasswordShow>
                              )
                            }
                            error={error.pwd}
                            helperText={
                              error.pwd
                                ? error.pwd
                                : !this.state.showPassInput
                                ? "Must contain at least 8 characters, 1 numeric and 1 special character."
                                : ""
                            }
                          />
                        </div>

                        {!error.pwd && this.state.showPassInput ? (
                          <div className="mt-4">
                            {userDetails.pwd &&
                            userDetails.pwd.match(strongRegex) ? (
                              <div className="mr-5">
                                <Typography.HelperText
                                  color="green"
                                  shade="300"
                                >
                                  {" "}
                                  &#10003; Must contain at least 8 characters, 1
                                  numeric and 1 special character.
                                </Typography.HelperText>
                              </div>
                            ) : this.state.focus ? (
                              <div>
                                <Typography.HelperText color="red" shade="200">
                                  Must contain at least 8 characters, 1 numeric
                                  and 1 special character.
                                </Typography.HelperText>
                              </div>
                            ) : (
                              <span className="mr-5">
                                <Typography.HelperText color="red" shade="200">
                                  Must contain at least 8 characters, 1 numeric
                                  and 1 special character.
                                </Typography.HelperText>
                              </span>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {error["all_fileds"] ? (
                    <Typography.HelperText>
                      {error["all_fileds"]}
                    </Typography.HelperText>
                  ) : null}

                  <Typography.HelperText
                    color="dark"
                    shade="c300"
                    className="mt-16 mb-16 fs-12"
                  >
                    By proceeding, you agree to
                    <a
                      className="pl-1"
                      href="https://www.xoxoday.com/terms-of-use"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <GreySpan> Terms of use </GreySpan>
                    </a>
                    <span className="px-1"> and </span>
                    <a
                      className="pr-1"
                      href="https://www.xoxoday.com/privacy-policy"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <GreySpan>Privacy policy </GreySpan>
                    </a>
                    of Xoxoday.
                  </Typography.HelperText>
                  {renderTurnstileCaptcha ? (
                    <Turnstile
                      className="text-center"
                      siteKey={TURNSTILE_SITE_KEY}
                      onSuccess={(token) => this.props.signUpFlow(token, true)}
                      options={{ theme: "light" }}
                      style={{ width: "100%" }}
                    />
                  ) : (
                    <Button
                      id="diySignup-signup"
                      type="submit"
                      className="w-100"
                      onClick={() =>
                        !signupLoader ? this.props.changeStep(true) : ""
                      }
                      disabled={
                        !signupLoader &&
                        userDetails.firstname &&
                        userDetails.company_name &&
                        userDetails.email &&
                        userDetails.pwd &&
                        Object.keys(error).length === 0 &&
                        !errorPhone
                          ? false
                          : true
                      }
                      size="large"
                    >
                      Sign up for FREE
                    </Button>
                  )}
                </Form>
              </div>
              <div className=" fs-12 mt-16 d-flex justify-content-between">
                <Typography.HelperText
                  component="div"
                  className="my-4"
                  color="dark"
                  shade="c300"
                >
                  Already have an account?
                  <a className="px-1" href={`${url}/marketplace/login`}>
                    <BlueSpan> Login</BlueSpan>
                  </a>
                </Typography.HelperText>
                <Typography.HelperText
                  component="div"
                  className="my-4"
                  shade="c300"
                >
                  Having trouble with Sign up?
                  <a
                    className="px-1"
                    href="https://www.xoxoday.com/company/contact-us"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BlueSpan> Get Help</BlueSpan>
                  </a>
                </Typography.HelperText>
              </div>
            </div>
          ) : (
            CompanyExistsView
          )}
        </div>
      </>
    );
  }
}

export default FirstStep;
